import { render } from "./CrStepSurface1Content.vue?vue&type=template&id=54926df4&scoped=true"
import script from "./CrStepSurface1Content.vue?vue&type=script&lang=js"
export * from "./CrStepSurface1Content.vue?vue&type=script&lang=js"

import "./CrStepSurface1Content.vue?vue&type=style&index=0&id=54926df4&scoped=true&lang=scss"

import exportComponent from "/home/forge/pga-beta.devserver6.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54926df4"]])

export default __exports__